module.exports = __webpack_public_path__ + "img/page-06.ea4224c7.jpg";